/*
 * -----------------------------------------------------------------------
 *  <copyright file="notification-snackbar.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Slide from '@mui/material/Slide';
import Snackbar from '@mui/material/Snackbar';
import React from 'react';

import INotificationSnackbarProps from './notification-snackbar.interface';

import './styles.scss';

const SlideTransition = (props: any) => <Slide {...props} direction="left" />;

const NotificationSnackbar = ({ open, onClose, position, message, autoHideDuration }: INotificationSnackbarProps) => {
    let errorStatus;

    if (message?.error) errorStatus = message?.error;
    else
        errorStatus = message
            ?.toLowerCase()
            .match(/error|already in use|matches existing|unable to create|already exists/);

    return (
        <Snackbar
            open={open}
            onClose={onClose}
            slots={{ transition: SlideTransition }}
            message={message?.error ? message.errorMessage : message}
            className={`notification-snackbar ${errorStatus ? 'error' : ''}`}
            autoHideDuration={autoHideDuration}
            anchorOrigin={{ vertical: position.vertical, horizontal: position.horizontal }}
            action={
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="notification-snackbar-icon fa-lg close-icon-cv"
                    onClick={onClose}
                />
            }
        />
    );
};

export default NotificationSnackbar;
